export default __webpack_public_path__ + "static/media/louvre.eb874f68.png";